module.exports = __webpack_public_path__ + "static/media/plan-TH4-desktop-tc.de38997e.png";